<template>
  <div class="container">
    <p
      class="title"
      :class="{uncheck:1,checked:formItem.value==1}"
      @click="changeCheckBox"
    >{{formItem.title}}</p>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { emitFormUpdate } from "../../tools/utils";
export default {
  props: ["formItem", "cm", "idx"],
  computed: {
    ...mapState(["_ticket"])
  },
  methods: {
    changeCheckBox() {
      if (this.formItem.field_status == 4) {
        return;
      }
      if (this.formItem.value == 1) {
        this.formItem.value = 0;
        this.formItem.valid = false;
      } else {
        this.formItem.value = 1;
        this.formItem.valid = true;
      }
      emitFormUpdate(this, this.idx);
      this.checkCommit();
    },
    checkCommit() {
      //if need add
      if (this.cm) {
        this.addInfo();
      } else {
        this.formItem.valid = true;
        emitFormUpdate(this, this.idx);
      }
    },
    //提交物料
    addInfo() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = this.formItem.value;
      if (this.formItem.clear_format) {
        val = this[this.formItem.format](val, true);
      }
      up.append(this.formItem.key, val);
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          // success do nothing
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.title {
  position: relative;
  font-size: 0.32rem;
  color: #4b4b4d;
  padding: 0.2rem 0 0.4rem 0.4rem;
}
.uncheck {
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0.2rem;
    width: 0.3rem;
    height: 0.3rem;
    background: url("../../images/icon_unselected.png") no-repeat;
    background-size: 100%;
  }
}
.checked {
  &::after {
    background: url("../../images/icon_selected.png") no-repeat;
    background-size: 100%;
  }
}
</style>


